import { LegalDocumentsTableHead } from "./LegalDocumentsTableHead";
import { cn } from "../../../utils/styles";
import { DocumentName } from "../documents/DocumentName";
import { bytesToKilobytes, download } from "../../../utils/file";
import React from "react";
import { DocumentsActionButton } from "../documents/DocumentsActionButton";
import { DocumentDownload } from "@carbon/icons-react";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../../utils/date";
import { useUserContext } from "../../../utils/contexts/UserProvider";

export const LegalDocumentsTable: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useUserContext();

  const agentParticipantDocuments = (
    user?.participant_agents.map(
      (agentParticipant) => agentParticipant?.latest_accepted_agreement,
    ) ?? []
  ).filter((value) => value);

  const documents = [
    user?.latest_agreement_file,
    user?.latest_gdpr_file,
    ...agentParticipantDocuments,
  ];

  return (
    <table>
      <LegalDocumentsTableHead />
      <tbody>
        {documents?.map((file, index) => (
          <React.Fragment key={file?.file_path}>
            {file ? (
              <tr className={cn("", index !== documents?.length - 1 && "border-b border-gray-100")}>
                <td className="px-6 py-4 flex items-center gap-5 w-[520px] h-[96px]">
                  <DocumentName
                    name={file.file_name}
                    file_type={file.file_type.replace(/\./g, "")}
                    description={formatDate(file.created_at)}
                  />
                </td>
                <td className="py-4 px-6 w-[120px]">
                  <p className="text-[16px]">{bytesToKilobytes(file?.file_size ?? 0)} KB</p>
                </td>
                <td className="py-4 px-6 w-[176px]">
                  <div className="flex items-center justify-center gap-3">
                    <DocumentsActionButton
                      label={t("Download")}
                      icon={DocumentDownload}
                      onClick={() => download(file)}
                    />
                  </div>
                </td>
              </tr>
            ) : null}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  );
};
